import { environment } from './environment';

export const commonEnvironments = {
  devBaseUrls: {
    isProd: false,
    keycloak: {
      url: 'https://auth.dev.qualisdigital.africa/auth',
      realm: 'AstraGate',
      clientId: 'astragate-merchant-portal-mfa',
    },
    astragate_token: 'https://developer.dev.astragate.africa/api/v1/clients',
    astragate_payment: 'https://api.dev.astragate.africa/v1/payment',
    astragate_callback: 'https://api.dev.astragate.africa/v1/payment/callback',
    astragate_sms: 'https://api.dev.astragate.africa/v1/sms',
    system_config:
      'https://system-configurations.dev.qualisdigital.africa/configurations/v1',
    salesOnboarding: 'https://onboarding-service.dev.qualisdigital.africa',
    environment_label: 'Sandbox Environment',
    environment_description:
      'This portal is intended for testing only. No live transactions will be processed.',
    environment_switch_label: 'Switch to Production',
    environment_switch_url: 'https://merchant.astragate.co',
  },

  preprodBaseUrls: {
    isProd: false,
    keycloak: {
      url: 'https://auth.qualisdigital.co/auth',
      realm: 'AstraGate',
      clientId: 'my-client',
    },
    astragate_token: 'https://developer.preprod.astragate.co/api/v1/clients',
    astragate_payment: 'https://api.preprod.astragate.co/v1/payment',
    astragate_callback: 'https://api.preprod.astragate.co/v1/payment/callback',
    astragate_sms: 'https://api.preprod.astragate.co/v1/sms',
    system_config:
      'https://system-configurations.preprod.qualisdigital.co/configurations/v1',
    salesOnboarding: 'https://onboarding-service.preprod.qualisdigital.africa',
    environment_label: 'Preprod Environment',
    environment_description:
      'This portal is intended for preprod testing and only be used by astragate team',
    environment_switch_label: 'Switch to Production',
    environment_switch_url: 'https://merchant.astragate.co',
  },

  prodBaseUrls: {
    isProd: true,
    keycloak: {
      url: 'https://auth.qualisdigital.africa/auth',
      realm: 'AstraGate',
      clientId: 'my-client',
    },
    astragate_token: 'https://developer.astragate.africa/api/v1/clients',
    astragate_payment: 'https://api.astragate.africa/v1/payment',
    astragate_sms: 'https://api.astragate.africa/v1/sms',
    astragate_callback: 'https://api.astragate.africa/v1/payment/callback',
    system_config:
      'https://system-configurations.qualisdigital.africa/configurations/v1',
    salesOnboarding: 'https://onboarding-service.qualisdigital.africa',
    environment_label: 'Production Environment',
    environment_description: 'You are using the live merchant portal.',
    environment_switch_label: 'Switch to Sandbox',
    environment_switch_url: 'https://merchant.dev.astragate.co',
  },
};
